import { render } from "./GlobalUploadStatus.vue?vue&type=template&id=60bccd12&scoped=true"
import script from "./GlobalUploadStatus.vue?vue&type=script&lang=js"
export * from "./GlobalUploadStatus.vue?vue&type=script&lang=js"

import "./GlobalUploadStatus.vue?vue&type=style&index=0&id=60bccd12&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60bccd12"]])

export default __exports__